import SyosPageComponent from '../components/SyosPageComponent';
import GraphicType from '../api/GraphicType';

/** @typedef {import("../SyosSeat").default} SyosSeat */

let cachedSeatTypeLabels;

function getSeatTypeLabels() {
  if (!cachedSeatTypeLabels) {
    cachedSeatTypeLabels = {
      [GraphicType.Wheelchair]: SyosPageComponent.labelSeatTypeWheelchairValue,
      [GraphicType.Star]: SyosPageComponent.labelSeatTypeSpecialValue,
      [GraphicType.EmptySet]: SyosPageComponent.labelSeatTypeNotForSale,
      unavailable: SyosPageComponent.labelSeatStatusUnavailable,
    };
  }

  return cachedSeatTypeLabels;
}

/**
 * @param {SyosSeat} seat
 */
function getSeatLabel(seat) {
  const isAvailable = seat.getIsAvailable();
  const zone = seat.getZone();

  const elements = [`${seat.row}${seat.number}`];

  if (isAvailable && zone) {
    appendSeatTypeLabels(seat, elements);
    elements.push(zone.accessiblePriceRange);
  } else {
    elements.push(getUnavailableSeatLabel(seat));
  }

  return elements.join(', ');
}

/**
 * @param {SyosSeat} seat
 */
function getSelectedSeatLabel(seat) {
  const {
    price_type_desc: description,
    displayPrice,
  } = seat.selectedPriceType;

  const elements = [`Remove ${seat.row}${seat.number}`];

  appendSeatTypeLabels(seat, elements);

  elements.push(description);
  elements.push(displayPrice);

  return elements.join(', ');
}

/**
 * @param {SyosSeat} seat
 * @param {string[]} elements
 */
function appendSeatTypeLabels(seat, elements) {
  const seatTypeLabels = getSeatTypeLabels();

  const seatTypeLabel = seatTypeLabels[seat.graphicType];

  if (seatTypeLabel) {
    if (seatTypeLabel !== 'Additional Info') {
      elements.push(seatTypeLabel);
    }

    if (seatTypeLabel !== seat.description) {
      elements.push(seat.description);
    }
  }
}

/**
 * @param {SyosSeat} seat
 */
function getUnavailableSeatLabel(seat) {
  const labels = getSeatTypeLabels();

  if (seat.graphicType === GraphicType.EmptySet) {
    return labels[GraphicType.EmptySet];
  }

  return labels.unavailable;
}

export default {
  getSeatLabel,
  getSelectedSeatLabel,
  getUnavailableSeatLabel,
};
